import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import type { IconProps } from '../../primitives/types.js';

/** Ruler — horizontal straightedge with alternating tick marks. Tick
 *  heights alternate (longer on whole units, shorter halfway) so the
 *  glyph reads as a measuring tool rather than a generic bar. */
export function IcnRuler(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="ruler">
      {/* Body */}
      <rect x="2" y="6" width="12" height="4" rx="0.5" />
      {/* Long ticks */}
      <path d="M4 6 V8.5" />
      <path d="M8 6 V8.5" />
      <path d="M12 6 V8.5" />
      {/* Short ticks */}
      <path d="M6 6 V7.5" />
      <path d="M10 6 V7.5" />
    </Svg>
  );
}
